export default __webpack_public_path__ + "static/media/Merchant-portal-reverse.ab36b118.png";